import printjs from 'print-js';
import { loadPdfMake } from './pdfmake-loader';

const createPdf = async (props:any, output = 'print') => {
  return new Promise(async(resolve, reject) => {
    try {
      // Carga diferida: pdfmake no viaja en el bundle inicial.
      const pdfMake = await loadPdfMake();
      const {
        pageSize = {
          width: 226.77,
          height: 841.88,
        },
        pageMargins = [5.66, 5.66, 5.66, 5.66],
        info = {
          title: 'F001-000001',
          author: 'maclode',
          subject: 'ticket',
          keywords: 'tck, sale',
        },
        styles = {
          header: {
            fontSize: 9,
            bold: true,
            alignment: 'center',
          },
          tHeaderLabel: {
            fontSize: 8,
            alignment: 'right',
          },
          tHeaderValue: {
            fontSize: 8,
            bold: true,
          },
          tProductsHeader: {
            fontSize: 8.5,
            bold: true,
          },
          tProductsBody: {
            fontSize: 8,
          },
          tTotals: {
            fontSize: 9,
            bold: true,
            alignment: 'right',
          },
          tClientLabel: {
            fontSize: 8,
            alignment: 'right',
          },
          tClientValue: {
            fontSize: 8,
            bold: true,
          },
          text: {
            fontSize: 8,
            alignment: 'center',
          },
          link: {
            fontSize: 8,
            bold: true,
            margin: [0, 0, 0, 4],
            alignment: 'center',
          },
          image: {
            height:90
          }
        },
        content,
      } = props;
      const docDefinition = {
        pageSize, //TAMAÑO HOJA
        pageMargins, //MARGENES HOJA
        info, //METADATA PDF
        content, // CONTENIDO PDF
        styles, //ESTILOS PDF
      };
      if (output === 'b64') {
        //SI INDICAMOS QUE LA SALIDA SERA [b64] Base64
        const pdfMakeCreatePdf = pdfMake.createPdf(docDefinition);
        pdfMakeCreatePdf.getBase64((data) => {
          resolve({
            success: true,
            content: data,
            message: 'Archivo generado correctamente.',
          });
        });
        return;
      }
      //ENVIAR A IMPRESIÓN DIRECTA
      if (output === 'print') {
        const pdfMakeCreatePdf = await pdfMake.createPdf(docDefinition);
        pdfMakeCreatePdf.getBase64((data) => {
        printjs({
            printable: data,
            type: 'pdf',
            base64: true,
          });

          resolve({
            success: true,
            content: null,
            message: 'Documento enviado a impresión.',
          });
        });
        return;
      }
      reject({
        success: false,
        content: null,
        message: 'Debes enviar tipo salida.',
      });
    } catch (error) {
      reject({
        success: false,
        content: null,
        message: 'No se pudo generar proceso.',
      });
    }
  });
};
export default createPdf;

// ─── Varios trabajos de impresión seguidos ─────────────────────────────────
// La impresora de tiquetes corta al final de cada trabajo, no entre páginas:
// para que dos copias salgan seguidas pero separadas, cada una va en su
// propio trabajo. print-js reutiliza un único iframe con id fijo y lo quita
// en el siguiente `focus`, así que dos llamadas seguidas se pisan; aquí cada
// copia lleva su iframe y se encadenan con `onLoadingEnd`, que print-js
// llama justo después de `print()`.
//
// Y entre un trabajo y el siguiente hay que ESPERAR: Chrome ignora sin avisar
// cualquier `print()` mientras otra impresión sigue en curso, y `print()`
// devuelve antes de que el trabajo haya salido al spooler (con impresión en
// modo kiosco, sin diálogo, ese hueco son unos cientos de milisegundos: la
// segunda copia se perdía y solo salía un tiquete). Así que tras cada copia:
// si se abrió un diálogo, se espera a que la página recupere el foco (se
// cerró); y en todo caso un margen fijo para que el trabajo salga.

const SEQUENCE_FRAME_PREFIX = 'printJS-seq-';

/** Si el iframe no llega a imprimir (visor de PDF bloqueado), la cola no se queda colgada. */
const PRINT_JOB_TIMEOUT_MS = 20000;
/** Tras `print()`: tiempo para que el diálogo, si lo hay, llegue a abrirse y quitarle el foco a la página. */
const PRINT_SETTLE_MS = 500;
/** Diálogo abierto (la página sin foco): se espera a que lo cierren hasta este máximo. */
const PRINT_DIALOG_TIMEOUT_MS = 120000;
/** Margen entre un trabajo y el siguiente para que Chrome lo entregue al spooler y acepte otro `print()`. */
const PRINT_JOB_GAP_MS = 2000;

function sleep(ms: number): Promise<void> {
  return new Promise<void>(resolve => setTimeout(resolve, ms));
}

/** La página tiene el foco (sin diálogo de impresión encima). Sin la API, se asume que sí. */
function pageHasFocus(): boolean {
  return typeof document.hasFocus === 'function' ? document.hasFocus() : true;
}

/**
 * Espera a que el trabajo recién mandado haya salido: primero a que se
 * cierre el diálogo de impresión si se abrió (mientras está abierto la
 * página no tiene el foco) y luego el margen fijo. Si la página ya estaba
 * sin foco antes de imprimir (el cajero tenía otra ventana delante) no hay
 * diálogo que esperar: solo el margen.
 */
async function waitForJobToLeave(hadFocus: boolean): Promise<void> {
  await sleep(PRINT_SETTLE_MS);
  if (hadFocus) {
    const start = Date.now();
    while (!pageHasFocus() && Date.now() - start < PRINT_DIALOG_TIMEOUT_MS) {
      await sleep(250);
    }
  }
  await sleep(PRINT_JOB_GAP_MS);
}

/** Los iframes de la cola anterior ya imprimieron: fuera, para no acumular visores de PDF. */
function removeSequenceFrames() {
  const frames = document.querySelectorAll(`iframe[id^="${SEQUENCE_FRAME_PREFIX}"]`);
  for (let i = 0; i < frames.length; i++) {
    const frame = frames[i];
    if (frame.parentNode) frame.parentNode.removeChild(frame);
  }
}

function printBase64Job(data: string, frameId: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve();
    };
    const timer = setTimeout(done, PRINT_JOB_TIMEOUT_MS);
    try {
      printjs({
        printable: data,
        type: 'pdf',
        base64: true,
        frameId,
        onLoadingEnd: done,
        onError: (error: any) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(error);
        },
      });
    } catch (error) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      reject(error);
    }
  });
}

/** Imprime cada PDF (base64) como un trabajo aparte, en orden y uno tras otro. */
export async function printPdfSequence(base64Docs: string[]): Promise<void> {
  removeSequenceFrames();
  for (let i = 0; i < base64Docs.length; i++) {
    const hadFocus = pageHasFocus();
    await printBase64Job(base64Docs[i], `${SEQUENCE_FRAME_PREFIX}${i + 1}`);
    // Después del último no hay nada que esperar: el modal de la caja se cierra ya.
    if (i < base64Docs.length - 1) await waitForJobToLeave(hadFocus);
  }
}
